export default "__VITE_ASSET__BWxF3LPQ__"